var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19624_10580)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83236 1.75195V4.58529C5.83236 5.052 5.83236 5.28535 5.92318 5.46361C6.00308 5.62041 6.13056 5.7479 6.28736 5.82779C6.46562 5.91862 6.69898 5.91862 7.16569 5.91862H12.8324C13.2991 5.91862 13.5324 5.91862 13.7107 5.82779C13.8675 5.7479 13.995 5.62041 14.0749 5.46361C14.1657 5.28535 14.1657 5.052 14.1657 4.58529V2.58529M14.1657 16.752V11.4186C14.1657 10.9519 14.1657 10.7186 14.0749 10.5403C13.995 10.3835 13.8675 10.256 13.7107 10.1761C13.5324 10.0853 13.2991 10.0853 12.8324 10.0853H7.16569C6.69898 10.0853 6.46562 10.0853 6.28736 10.1761C6.13056 10.256 6.00308 10.3835 5.92318 10.5403C5.83236 10.7186 5.83236 10.9519 5.83236 11.4186V16.752M17.499 7.02319V12.752C17.499 14.1521 17.499 14.8521 17.2265 15.3869C16.9869 15.8573 16.6044 16.2398 16.134 16.4795C15.5992 16.752 14.8992 16.752 13.499 16.752H6.49902C5.09889 16.752 4.39883 16.752 3.86405 16.4795C3.39364 16.2398 3.01119 15.8573 2.77151 15.3869C2.49902 14.8521 2.49902 14.1521 2.49902 12.752V5.75195C2.49902 4.35182 2.49902 3.65176 2.77151 3.11698C3.01119 2.64657 3.39364 2.26412 3.86405 2.02444C4.39883 1.75195 5.09889 1.75195 6.49902 1.75195H12.2278C12.6354 1.75195 12.8393 1.75195 13.0311 1.798C13.2011 1.83883 13.3637 1.90617 13.5128 1.99755C13.681 2.10062 13.8252 2.24475 14.1134 2.533L16.718 5.13757C17.0062 5.42582 17.1504 5.56995 17.2534 5.73814C17.3448 5.88726 17.4121 6.04984 17.453 6.2199C17.499 6.41171 17.499 6.61554 17.499 7.02319Z",
    stroke: "#F7F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19624_10580"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(-0.000976562 0.0854492)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave01);
export default __webpack_public_path__ + "static/media/save-01.f4adf02e16f3bb28a73e89d83674f887.svg";
export { ForwardRef as ReactComponent };